import React, { useState, useEffect } from 'react';
import maPhoto from '../../assets/images/photo_Clément_BOURGA.jpg';

const Accueil = () => {
  const [currentArticleIndex, setCurrentArticleIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  const newsArticles = [
    {
      id: 1,
      category: "Droit de l'UE",
      title: "CJUE 2025 : Comment obtenir réparation pour les pratiques anticoncurrentielles ?",
      text: "La Cour de justice de l’UE facilite les actions groupées contre les ententes illicites. Découvrez les implications pour votre entreprise et comment nous pouvons vous accompagner.",
      link: "/articles/droit-ue-reparation-pratiques-anticoncurrentielles-2025",
      date: "Avril 2025",
      highlight: "Une opportunité pour les victimes de récupérer leurs pertes"
    },
    {
      id: 2,
      category: "Droit de l'UE",
      title: "Google condamné à 2,95 milliards d’euros : Que risque votre secteur ?",
      text: "Analyse des amendes record de l’UE contre les géants du numérique et des risques pour les entreprises françaises. Nos experts vous éclairent.",
      link: "/articles/amendes-ue-google-pratiques-anticoncurrentielles-2025",
      date: "Septembre 2025",
      highlight: "Un signal fort pour la concurrence loyale en Europe"
    },
    {
      id: 3,
      category: "IFRS",
      title: "IFRS 18 : Tout ce que vous devez savoir pour préparer vos états financiers 2027",
      text: "La nouvelle norme IFRS 18 remplace IAS 1 et transforme la présentation des comptes. Nos conseils pour une transition réussie.",
      link: "/articles/ifrs-18-nouveautes-etats-financiers-2027",
      date: "Juillet 2025",
      highlight: "Anticipez dès maintenant avec notre guide pratique"
    },
    {
      id: 4,
      category: "IFRS",
      title: "IFRS 2025-2026 : Les amendements à IAS 21 et IFRS 7/9 décryptés",
      text: "Convertibilité des devises, contrats d’électricité renouvelable : ce qui change pour vos comptes consolidés. Téléchargez notre fiche synthétique.",
      link: "/articles/ifrs-2025-amendements-ias21-ifrs7",
      date: "Février 2025",
      highlight: "Des impacts directs sur votre reporting financier"
    },
    {
      id: 5,
      category: "Fiscalité 2026",
      title: "Loi de finances 2026 : 5 mesures qui vont impacter votre fiscalité",
      text: "Gel du barème de l’impôt, suppression de l’abattement retraite, nouvelles taxes… Nos experts analysent les changements et vous proposent des solutions d’optimisation.",
      link: "/articles/loi-finances-2026-mesures-fiscales",
      date: "Octobre 2025",
      highlight: "Préparez-vous avec notre webinaire exclusif"
    },
    {
      id: 6,
      category: "Fiscalité 2026",
      title: "Budget 2026 : Ce qui a été adopté (et comment en tirer parti)",
      text: "Heures supplémentaires défiscalisées, taxe Gafam, abattement retraite… Décryptage des mesures et stratégies pour optimiser votre fiscalité.",
      link: "/articles/budget-2026-mesures-adoptees-strategies",
      date: "Novembre 2025",
      highlight: "Un budget sous tension : nos recommandations clés"
    },
    {
      id: 7,
      category: "Transformation digitale",
      title: "Baromètre 2025 : Où en sont les PME dans leur transformation digitale ?",
      text: "80% des PME ont engagé leur digitalisation, mais les défis restent nombreux. Découvrez les tendances et nos solutions pour accélérer votre transition.",
      link: "/articles/transformation-digitale-pme-barometre-2025",
      date: "Septembre 2025",
      highlight: "Cybersécurité, IA, efficacité opérationnelle : les priorités 2026"
    },
    {
      id: 8,
      category: "Transformation digitale",
      title: "Transformation digitale : Comment en faire un levier de croissance ?",
      text: "Au-delà du site vitrine, le numérique doit servir votre stratégie. Nos experts vous guident pour une digitalisation efficace et rentable.",
      link: "/articles/transformation-digitale-levier-croissance",
      date: "Octobre 2025",
      highlight: "Cas clients : +20% de productivité grâce au digital"
    },
    {
      id: 9,
      category: "Transformation digitale",
      title: "Mesurer les gains de la transformation digitale : Méthodes et outils",
      text: "Coûts, délais, qualité, productivité… Comment évaluer l’impact réel de votre digitalisation ? Nos outils et benchmarks pour piloter votre projet.",
      link: "/articles/mesurer-gains-transformation-digitale",
      date: "Novembre 2025",
      highlight: "Baromètre Niji 2025 : Les clés d’une transformation réussie"
    },
    {
      id: 10,
      category: "Webinaires",
      title: "[Webinaire] Transformation digitale : Enjeux 2026 pour les PME",
      text: "Inscrivez-vous à notre webinaire gratuit pour comprendre les défis de la digitalisation et découvrir des solutions concrètes adaptées aux PME.",
      link: "/articles/webinaire-transformation-digitale-2026",
      date: "Décembre 2025",
      highlight: "Réservez votre place dès maintenant !"
    }
  ];

  // Défilement automatique
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentArticleIndex((prevIndex) =>
          prevIndex === newsArticles.length - 1 ? 0 : prevIndex + 1
        );
        setIsFading(false);
      }, 500); // Temps de l'animation
    }, 10000); // 10 secondes

    return () => clearInterval(interval);
  }, [newsArticles.length]);

  return (
    <div className="home-page">
      {/* Bannière hero */}
      <section className="hero-section">
        <h1 className="hero-title">Optimisez votre gestion financière</h1>
        <p className="hero-subtitle">
          Des solutions sur mesure pour les entreprises ambitieuses, alliant expertise locale et vision internationale.
        </p>
        <button className="hero-button">Découvrir nos services</button>
      </section>

      {/* Services */}
      <section className="services-section">
        <h2 className="section-title">Nos services</h2>
        <div className="service-cards">
          <div className="service-card">
            <h3 className="service-card-title">Audit</h3>
            <p className="service-card-text">
              Expertise et rigueur pour vos obligations légales et une transparence totale.
            </p>
          </div>
          <div className="service-card">
            <h3 className="service-card-title">Fiscalité</h3>
            <p className="service-card-text">
              Optimisation et conformité fiscale pour sécuriser votre activité.
            </p>
          </div>
          <div className="service-card">
            <h3 className="service-card-title">Conseil</h3>
            <p className="service-card-text">
              Accompagnement stratégique pour votre croissance et votre transformation.
            </p>
          </div>
        </div>
      </section>

      {/* Actualités */}
      <section className="news-section">
        <h2 className="section-title">Actualités</h2>
        <div className="news-articles-container">
          <div className={`news-articles ${isFading ? 'fade' : ''}`}>
            <a
              href={newsArticles[currentArticleIndex].link}
              className="news-article-link"
            >
              <article className="news-article">
                <div className="news-article-category">{newsArticles[currentArticleIndex].category}</div>
                <h4 className="news-article-title">
                  {newsArticles[currentArticleIndex].title}
                </h4>
                <p className="news-article-text">
                  {newsArticles[currentArticleIndex].text}
                </p>
                <div className="news-article-highlight">
                  {newsArticles[currentArticleIndex].highlight}
                </div>
              </article>
            </a>
          </div>
          {/* Indicateurs */}
          <div className="news-dots">
            {newsArticles.map((_, index) => (
              <span
                key={index}
                className={`news-dot ${index === currentArticleIndex ? 'active' : ''}`}
                onClick={() => {
                  setIsFading(true);
                  setTimeout(() => {
                    setCurrentArticleIndex(index);
                    setIsFading(false);
                  }, 500);
                }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Engagements */}
      <section className="engagements-section">
        <div className="engagements-overlay"></div>
        <div className="engagements-content">
          <h2 className="engagements-title">Nos engagements</h2>
          <p className="engagements-text">
            Nous nous engageons à vos côtés pour un accompagnement responsable, innovant et centré sur vos besoins.
          </p>
          <div className="engagement-items">
            <div className="engagement-item">
              <h4 className="engagement-item-title">RSE</h4>
              <p className="engagement-item-text">
                Notre engagement pour un impact social et environnemental positif.
              </p>
            </div>
            <div className="engagement-item">
              <h4 className="engagement-item-title">Innovation</h4>
              <p className="engagement-item-text">
                Des solutions adaptées aux enjeux de demain.
              </p>
            </div>
            <div className="engagement-item">
              <h4 className="engagement-item-title">Proximité</h4>
              <p className="engagement-item-text">
                Un partenaire à vos côtés, où que vous soyez.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* À propos */}
      <section className="about-section">
        <h2 className="about-title">Qui sommes-nous ?</h2>
        <img
          src={maPhoto}
          alt="Clément Bourga, Expert en audit et conseil financier"
          className="about-photo"
        />
        <p className="about-text">
          Expert en audit financier et conseil aux entreprises, je vous accompagne pour optimiser votre gestion et anticiper les enjeux réglementaires et digitaux.
          Spécialisé dans les normes IFRS, la fiscalité et la transformation digitale, je mets mon expertise à votre service pour des solutions sur mesure et innovantes.
        </p>
        <a
          href="https://www.linkedin.com/in/clément-bourga-b9090b24a/"
          target="_blank"
          rel="noopener noreferrer"
          className="about-linkedin"
        >
          <img
            src="https://content.linkedin.com/content/dam/me/business/en-us/amp/brand-site/v2/bg/LI-Bug.svg.original.svg"
            alt="LinkedIn"
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
          <span>Découvrir mon profil LinkedIn</span>
        </a>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p className="footer-text">© 2025 Mon Cabinet. Tous droits réservés.</p>
        <p className="footer-locations">Toulouse · Paris · International</p>
      </footer>
    </div>
  );
};

export default Accueil;
